import JewelryInquiryFormQuery from "Query/JewelryInquiry.query";
import { showNotification } from 'Store/Notification/Notification.action';
import { NotificationType } from 'Store/Notification/Notification.type';
import { getErrorMessage } from 'Util/Request/Error';
import { fetchMutation } from 'Util/Request/Mutation';
import { updateJewelryInquiry } from "./JewelryInquiry.action";

export class JewelryInquiryDispatcher {
    prepareRequest(options, dispatch) {
        const { form = {}, fields = {} } = options;

        const mutation = JewelryInquiryFormQuery.getSendJewelryInquiryMutation(fields);

        dispatch(updateJewelryInquiry({
            isLoading: true,
        }));

        return fetchMutation(mutation)
            .then(
                (data) => {
                    dispatch(showNotification(NotificationType.SUCCESS, data.JewelryInqury.message || ''));
                    dispatch(updateJewelryInquiry({
                        isLoading: false,
                    }));

                    if (typeof form.reset === 'function') {
                        form.reset();
                    }
                },

                (error) => {
                    dispatch(showNotification(NotificationType.ERROR, getErrorMessage(error)));
                    dispatch(updateJewelryInquiry({
                        isLoading: false,
                    }));
                },
            );
    }
}

export default new JewelryInquiryDispatcher();